import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Card from 'pages/card/Card';

const CardRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Card />} />
    </Routes>
  );
};

export default CardRouter;
